import { Grid } from "@mui/material";
import { useCardContext } from "../../CardBuilder";
import { DefaultOptions } from "../common/DefaultOptions";
import { DeleteButton } from "../common/DeleteButton";
import { EditButton } from "../common/EditButton";
import { ThreadMasterButton } from "../common/ThreadItemFooter";

export const DraftThreadFooter = () => {

    const { pub: { interaction: { allowEdit } } } = useCardContext();

    return (
        <Grid container justifyContent="space-between" alignItems="center">
            <Grid>
                <Grid container spacing={2} justifyContent="center" alignItems="center">
                    <Grid>
                        <ThreadMasterButton />
                    </Grid>
                    {allowEdit &&
                        <Grid>
                            <EditButton />
                        </Grid>
                    }
                    <Grid>
                        <DeleteButton />
                    </Grid>
                </Grid>
            </Grid>
            <Grid>
                <Grid container justifyContent="center" alignItems="center">
                    <Grid>
                        <DefaultOptions />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};


export const DraftFooter = () => {

    return (
        <Grid container justifyContent="space-between" alignItems="center">
            <Grid>
                <Grid container spacing={2} justifyContent="center" alignItems="center">
                    <Grid>
                        <EditButton />
                    </Grid>
                    <Grid>
                        <DeleteButton />
                    </Grid>
                </Grid>
            </Grid>
            <Grid>
                <Grid container justifyContent="center" alignItems="center">
                    <Grid>
                        <DefaultOptions />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};
